import React from "react";
import PropTypes from "prop-types";
import { useMediaQuery } from "react-responsive";
import ExtraScoresMobile from "./ExtraScoresMobile";
import ExtraScoresDesktop from "./ExtraScoresDesktop";

function ExtraScores({ app, config }) {
  const isMobile = useMediaQuery({ query: "(max-width: 980px)" });

  return <ExtraScoresDesktop app={app} config={config} />;
}

ExtraScores.defaultProps = {
  app: null,
  config: {},
};

ExtraScores.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default ExtraScores;
